import { useState } from 'react';
import { ChevronDown, ChevronUp, Plus } from 'lucide-react';

/**
 * FoldableSection - A collapsible section component with title and toggle
 * Features smooth animation for opening/closing
 */
export default function FoldableSection({ title, children, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-b border-border">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-3 px-4 text-left hover:bg-muted/50 transition-colors"
      >
        <span className="text-sm font-semibold text-foreground">{title}</span>
        {isOpen ? (
          <ChevronUp className="h-4 w-4 text-muted-foreground" />
        ) : (
          <Plus className="h-4 w-4 text-muted-foreground" />
        )}
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 pb-4 text-sm text-muted-foreground">
          {children}
        </div>
      </div>
    </div>
  );
}
